// Re-export Firebase instances from DashONE's shared initialization.
// This avoids creating a second Firebase app instance.
// DashONE's firebase.js already handles environment-based config (dev/stg/prod).
import { auth, db, STORAGE_BUCKET } from '@/utils/firebase';
import { getFunctions } from 'firebase/functions';
import { GoogleAuthProvider } from 'firebase/auth';

export { auth, db, STORAGE_BUCKET };
export const functions = getFunctions(auth.app, 'us-central1');
export const googleProvider = new GoogleAuthProvider();

export default auth.app;
